import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { isAuthenticated, clearToken } from '../utils/auth';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState('checking'); // checking | ok | denied

  useEffect(() => {
    if (!isAuthenticated()) {
      setStatus('denied');
      return;
    }
    axios.get(`${API}/auth/me`)
      .then(() => setStatus('ok'))
      .catch(() => {
        clearToken();
        setStatus('denied');
      });
  }, []);

  if (status === 'checking') {
    return (
      <div className="min-h-screen bg-[#0a1628] flex items-center justify-center">
        <div className="text-white/60">Verificando sessão...</div>
      </div>
    );
  }

  if (status === 'denied') {
    return <Navigate to="/login" replace />;
  }

  return children;
};
